import React from 'react';
import useTextContents from '../../hooks/useTextContents'
import {ReactComponent as ErrorIcon} from '../../icons/svg/error-page-icon.svg';

import "./ErrorPage.scss";
import Paragraph from "../../components/atoms/Paragraph/Paragraph";
import PageScreen from "../../components/organisms/Page/PageScreen";
import {AppIconProps} from "../../components/atoms/AppIcon/AppIconProps";

const ErrorPage = () => {

    const textContents = useTextContents()

    return (
        <PageScreen
            title={{title: textContents('errorPage.heading'), line: false}}
            icon={{
                icon: ErrorIcon,
                label: 'Label'
            }}
            showBackButton={false}>
            <Paragraph align={"center"}>
                {textContents('errorPage.mainContent')}
            </Paragraph>
            <Paragraph align={"center"} bold={true}>
                {textContents('errorPage.tip')}
            </Paragraph>
        </PageScreen>


    );
};

export default ErrorPage;
  